import { ACP } from '../constants.mjs';

//
/**
 * Retrieve the URL of an Access Control Resource as per pre-draft versions of
 * the ACP specification.
 *
 * @param resource The Resource for which to retrieve the URL of the Access
 * Control Resource if it is accessible.
 * @returns The URL of the ACR or null.
 * @deprecated
 */
function getAcrUrl(resource) {
    const linkedAccessControlResource = resource.internal_resourceInfo.linkedResources[ACP.accessControl];
    if (Array.isArray(linkedAccessControlResource) &&
        linkedAccessControlResource.length === 1) {
        return linkedAccessControlResource[0];
    }
    return null;
}

export { getAcrUrl };
